export function getValueOfQueryParam(paramName: string): string {
	const urlParams = new URLSearchParams(location.search)

	return urlParams.get(paramName)
}
